import {remCalc} from '../../_utils'
import {StyleFunctionProps} from '@chakra-ui/theme-tools'

/**
 * the feedback style
 */

export default {
    baseStyle: {
        '.chakra-toast__inner': {
            minWidth: 0,
            maxWidth: {
                base: 'calc(100vw - 32px)',
                lg: 'fit-content',
            },
            width: {
                base: 'calc(100vw - 32px)',
                lg: 'fit-content',
            },
            marginInline: {
                base: '16px',
                lg: 0,
            },
        },
        container: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingY: remCalc(16),
            paddingX: remCalc(20),
            border: '1px solid var(--chakra-colors-border-neutral-highlight)',
            borderRadius: 'xl',
            gap: remCalc(12),
            color: 'text.success',
            textStyle: 'body-small',
            lineHeight: remCalc(18),
            bg: 'grey',
            width: {
                base: '100%',
                lg: 'fit-content',
            },
            marginInline: 'auto',
        },
        textContainer: {
            alignItems: 'flex-start',
            justifyContent: 'center',
            gap: 0,
        },
        messageText: {
            fontWeight: 'regular',
        },
        descriptionText: {
            fontWeight: 'regular',
        },
        statusIcon: {
            width: remCalc(20),
            height: remCalc(20),
        },
        closeIcon: {
            width: remCalc(16),
            height: remCalc(16),
        },
        undoButton: {
            bg: 'background.positive.default',
            color: 'background.positive.muted',
        },
    },
    variants: {
        // guestWishlistFeedback: {
        //     container: {
        //         display: 'flex',
        //         height: 'auto',
        //         bg: 'background.default',
        //         color: 'text.default',
        //         borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
        //         border: 'small',
        //         borderStyle: 'solid',
        //         borderColor: 'border.light',
        //         width: {base: '100%', md: remCalc(451)},
        //         padding: remCalc(26),
        //         flexDirection: 'column',
        //         alignItems: 'flex-start',
        //         gap: remCalc(22),
        //         textStyle: 'body-small',
        //     },
        //     statusIcon: {
        //         color: 'text.success',
        //     },
        //     closeIcon: {
        //         display: 'none',
        //     },
        // },
        // wishlistFeedback: {
        //     container: {
        //         bg: 'background.default',
        //         color: 'text.default',
        //         borderRadius: ['large.base', 'large.sm', 'large.md', 'large.lg'],
        //         border: 'small',
        //         borderStyle: 'solid',
        //         borderColor: 'border.light',
        //         textStyle: 'body-small',
        //         width: {base: '100%', md: remCalc(451)},
        //         padding: remCalc(26),
        //     },
        //     statusIcon: {
        //         color: 'text.success',
        //     },
        //     closeIcon: {
        //         width: 'iconsSize.medium',
        //         height: 'iconsSize.medium',
        //         color: 'background.dark',
        //     },
        // },
        // removeFeedback: {
        //     container: {
        //         color: 'text.secondary',
        //         textStyle: 'body-small',
        //         fontWeight: 'normal',
        //         w: '100%',
        //         h: 'auto',
        //         maxHeight: remCalc(92),
        //         bg: 'background.success',
        //     },
        // },
        // vatWarning: {
        //     container: {
        //         display: 'flex',
        //         minWidth: remCalc(343),
        //         padding: remCalc(26),
        //         flexDir: 'column',
        //         alignItems: 'flex-start',
        //         gap: remCalc(22),
        //         alignSelf: 'stretch',
        //         bg: 'background.light',
        //         color: 'text.default',
        //         w: '100%',
        //         h: 'auto',
        //         textStyle: 'body-small',
        //         fontWeight: 'normal',
        //     },
        //     innerContainer: {
        //         display: 'flex',
        //         justifyContent: 'space-between',
        //         alignItems: 'flex-start',
        //         alignContent: 'flex-start',
        //         rowGap: remCalc(13),
        //         alignSelf: 'stretch',
        //         flexWrap: 'wrap',
        //     },
        // },
        // removeFeedbackWishlist: {
        //     container: {
        //         color: 'text.secondary',
        //         textStyle: 'body-small',
        //         fontWeight: 'normal',
        //         w: '100%',
        //         h: 'auto',
        //         maxHeight: remCalc(92),
        //         bg: 'background.success',
        //     },
        // },
        // freeItemPromo: {
        //     container: {
        //         display: 'flex',
        //         flexDir: 'column',
        //         color: 'text.secondary',
        //         textStyle: 'body-small',
        //         fontWeight: 'normal',
        //         w: '100%',
        //         h: 'auto',
        //         padding: 'small.base',
        //         maxHeight: remCalc(120),
        //         bg: 'background.info',
        //         gap: 'small.base',
        //         borderRadius: 'large.base',
        //         minWidth: remCalc(200),
        //     },
        // },
        default: (props: StyleFunctionProps) => {
            return {
                container: {
                    bg: `${
                        props.status === 'success'
                            ? 'background.positive.muted'
                            : 'background.negative.muted'
                    }`,
                    boxShadow: `${
                        props.status === 'success'
                            ? '0 0 0 1px var(--chakra-colors-border-positive-lg, rgba(0, 105, 51, 0.24)), 0 4px 8px 0 var(--chakra-colors-border-positive-xs, rgba(0, 105, 51, 0.08)), 0 6px 23px 0 var(--chakra-colors-border-positive-xs, rgba(0, 105, 51, 0.08))'
                            : '0 0 0 1px var(--chakra-shadows-negative-lg), 0 4px 8px 0 var(--chakra-shadows-negative-xs), 0 6px 23px 0 var(--chakra-shadows-negative-xs)'
                    }`,
                    color: `${
                        props.status === 'success'
                            ? 'foreground.positive.default'
                            : 'foreground.negative.default'
                    }`,
                },
                closeIcon: {
                    color:
                        props.status === 'success'
                            ? 'foreground.positive.default'
                            : 'foreground.negative.default',
                },
            }
        },
    },
    defaultProps: {
        variant: 'default',
    },

    parts: ['container', 'statusIcon', 'closeIcon'],
}
